import store from "@/store.js";
import { sha256 } from "js-sha256";
import { appModelDate, toYYMMDDHMS } from "@/utils/utils";
import { Notify } from "@nutui/nutui";
const host = window.location.host;
let token = "AblTUgITSz4rl3zoWcLm1OvHvf0fv4vD";
if (host === "huituactivity.map.qq.com") token = "YK70t3hWw0KYykq9NOTWaUhsBkeKU60V";
if (host === "huituactivitytest.map.qq.com")
  token = "AblTUgITSz4rl3zoWcLm1OvHvf0fv4vD";

const easyearn = window.easyearn

export default function fetchApi(method, url, data) {
  // bool 匹配需要token不要openid的url
  const urlMap = ['mizar', 'lotteries', 'address', '/activity/']
  let bool = false;
  const arr = urlMap.filter(item => url.includes(item))
  bool = arr.length > 0 ? true : false
  // 判断是否是  mizar/integration/task/conf/list  这个api不能删除openId
  const IsTokenApi = url.includes("access_token");
  // console.log(IsTokenApi, 'IsTokenApi');
  const IsCos = url.includes("getCos") && !url.includes('getCosCredentialsByScene');
  const date = Date.parse(appModelDate(toYYMMDDHMS(new Date()))) / 1000;

  const getHeaderInfo = () => {
    const headerInfo = {
      "x-requested-with": "fetch",
      Pragma: "no-cache",
      
      Accept: "application/json",
      credentials: "include", // cookie设置
      mode: "cors", // 跨域
      "Content-Type": "application/json;charset=UTF-8",
      Openid: store.getters.huituOpenid || "",
      Timestamp: date,
      Signature: sha256(
        `${date},${token},${store.getters.huituOpenid || ""},${""},${date}`
      ).toUpperCase(),
      versioncode: store.getters.versioncode || "",
      version: store.getters.versioncode || "",
    };
    if (headerInfo["versioncode"] == "") {
      delete headerInfo["versioncode"];
    }
    // console.log(bool, !IsCos, !store.getters.haveOpenId);
    if (bool && !IsCos && !store.getters.haveOpenId) {
      if(!url.includes('mizar/integration/task/conf/list')){
        delete headerInfo["Openid"];
        delete headerInfo["Signature"];
      }
      if (!IsTokenApi) {
        headerInfo.Authorization = "Bearer " + store.getters.accessToken || "";
      }
    }
    // headerInfo.versioncode = 32102007;
    // headerInfo.Authorization = 'Bearer f3581a6369534e06b1577a77a1530d30';
    return headerInfo;
  };

  // token 失效处理（访问令牌过期 / 刷新令牌过期 / 无效令牌）。
  // 出于安全考虑，H5 不再持有 OAuth 密钥自行刷新 token：
  // - 小程序场景：由小程序在打开 web-view 前预刷新 token 注入 H5，正常会话内不会过期；
  //   若极端情况下会话中途仍过期，H5 无自刷新能力，仅做轻提示，交由用户返回重新进入。
  // - APP 场景：复用现有 easyearn.updateToken 通知，由 APP 侧刷新/重新注入 token。
  const handleTokenInvalid = (code) => {
    if (store.getters.isH5) {
      Notify.warn("登录状态已过期，请返回重新进入");
    } else {
      easyearn && easyearn.updateToken
        ? easyearn.updateToken(null, null, code)
        : "";
    }
  };

  const handleSuccessResponse = (res) => {
    return Promise.resolve(res);
  };

  const handleError = (err) => {
    console.log(err, "err");
    return Promise.reject(err)
  };

  const requestOptions = {
    method,
    headers: getHeaderInfo(),
    cache: "no-cache",
    body: data ? JSON.stringify(data) : null,
  };

  return fetch(url, requestOptions)
    .then((response) => response.json())
    .then((res) => {
      // 处理错误码
      switch (Number(res.code)) {
        case 200001: // 访问令牌过期
        case 200002: // 刷新令牌过期
        case 200003: // 无效的访问令牌
        case 200004: // 无效的刷新令牌
          handleTokenInvalid(Number(res.code));
          break;
        case 200005: // 非法请求
          Notify.danger("非法请求");
          break;
        default:
          return handleSuccessResponse(res);
      }
    })
    .catch(handleError);
}